import { NextButton, PreviousButton } from '@library/components/buttons';
import { augmentDay, determineIsInDateRange } from '@library/utils';

export interface DatePickerPrevNextButtonsProps {
  date: Date | undefined;
  disabled?: boolean;
  handleChange: (value: Date) => void;
  maxDate?: Date;
  minDate?: Date;
  testIdPrefix?: string;
}

export const DatePickerPrevNextButtons = ({
  date,
  disabled = false,
  handleChange,
  maxDate = undefined,
  minDate = undefined,
  testIdPrefix = ''
}: DatePickerPrevNextButtonsProps) => {
  const handleArrowClick = (direction: 'next' | 'previous') => {
    const newDay = date ? augmentDay(direction, date) : undefined;

    if (!newDay) {
      return;
    }

    const isInDateRange = determineIsInDateRange(newDay, maxDate, minDate);

    if (!isInDateRange) {
      return;
    }

    handleChange(newDay);
  };

  return (
    <>
      <PreviousButton
        disabled={disabled}
        handleOnClick={() => handleArrowClick('previous')}
        label="Previous Day"
        testId={`${testIdPrefix}previous-day-button`}
      />
      <NextButton
        disabled={disabled}
        handleOnClick={() => handleArrowClick('next')}
        label="Next Day"
        testId={`${testIdPrefix}next-day-button`}
      />
    </>
  );
};
